import { useTheme } from "next-themes";
import { useTranslations } from "next-intl";
import { Moon, Sun } from "lucide-react";

const ThemeToggleMobile = () => {
    const t = useTranslations("Header.themes");
    const { theme, setTheme } = useTheme();

    return (
        <div className={'transition-transform overflow-hidden rounded-sm w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-none'} onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}>
            <div className="flex gap-4 dark:text-white font-bold p-4 justify-between">
                {
                    theme === 'light' ?
                        t(theme)
                        : t('dark')
                }
                {
                    theme === 'light' ? <Sun /> : <Moon />
                }
            </div>
        </div>
    );
};

export default ThemeToggleMobile;